function Spacer({width, height, vertical}) {
	return (
		<span style={{display: height || vertical ? 'block' : 'inline-block', width: width ? width : 12, height: height ? height : 12}}/>
	);
}

export default Spacer;